import React,  {Component }from 'react'; 
import moment from 'moment';
import './ChartsStyle.css'; 
import Plot from '../../../utils/customPlotly'; 
import ChartDataTransformer from './ChartTransformation';
import StoriesChartDataTransformer from './StoriesChartTransformation';

class Chart extends Component {
  render() {
    console.log(this.props)
    return (
      <Plot
        data={this.props.chartValue==="Overview"? 
         ChartDataTransformer.transform(this.props.chartAnalytics, this.props.chartMetrices, this.props.searchObject)
        :StoriesChartDataTransformer.transform(this.props.chartAnalytics, this.props.chartMetrices, this.props.searchObject)}
        layout={{
          showlegend: true,
          autosize: true,
          legend: {
            orientation: 'v'
          },
          paper_bgcolor: '#F3F3F4',
          plot_bgcolor: '#F3F3F4',
          margin: {
            l: 60,
            r: 10,
            b: 60,
            t: 60,
            pad: 4,
          },
          xaxis: {
            title: "Date",
            showgrid: false,
            autorange: true
          },
          yaxis: {
            title: 'Count',
            zerolinecolor: '#ffffff',
            zerolinewidth: 2,
            gridcolor: '#ffffff',
            gridwidth: 2,
            tickfont: { color: '#313236' },
            autorange: true,
            rangemode: 'tozero',
            tickformat: 'd'
          },
          hovermode: 'x'
        }}
        useResizeHandler={true}
        // config={{ displayModeBar: false }}
        config={{
          displayModeBar:true, 
          displaylogo: false,
          responsive: true,
          // modeBarButtonsToRemove: ['toImage']
          toImageButtonOptions: {
            format: 'svg', // one of png, svg, jpeg, webp
            // moment(d.createdDate).format('MM/DD/YYYY')
            filename: `${this.props.chartValue} - ${moment(new Date()).format('MM-D-YYYY')}`,
            height: 500,
            width: 700,
            scale: 1 // Multiply title/legend/axis/canvas sizes by this factor
          }
          // toImageButtonOptions: {filename: moment()._d }
        }}
        style={{ width: '100%', height: '300px' }}
      />)
  }
}

export default Chart; 